// Session orchestrator: owns the store + all capture channels for one recording.
// Order matters: the store (t0) and structured listeners come up FIRST so the timeline has no
// head gap, then audio, then rrweb. There is no pause — audio is continuous from t0 to stop,
// which is the invariant that keeps transcript timestamps aligned with timeline tMs.

import { createStore } from '../store.js';
import { startRrweb } from './rrweb.js';
import { startClicks } from './clicks.js';
import { startNetwork } from './network.js';
import { startConsole } from './console.js';
import { startRoutes } from './routes.js';

export async function startSession(cfg, audio) {
  const store = createStore();
  const teardown = [];

  teardown.push(startClicks((ev) => store.push(ev)));
  teardown.push(startNetwork((ev) => store.push(ev), cfg));
  teardown.push(startConsole((ev) => store.push(ev)));
  teardown.push(startRoutes((ev) => store.push(ev)));

  if (audio) audio.start();

  const rr = await startRrweb((ev) => store.pushRrweb(ev), cfg);
  teardown.push(() => rr.stop());

  return {
    store,
    analyser: audio ? audio.analyser : null,

    async stop() {
      teardown.forEach((fn) => { try { fn(); } catch (_) {} });
      const audioBlob = audio ? await audio.stop() : null;
      const endedAt = Date.now();
      store.context.endedAt = new Date(endedAt).toISOString();
      store.context.durationMs = endedAt - store.startedAt;
      return { store, audioBlob };
    },
  };
}
